module.exports = __webpack_public_path__ + "static/media/symblox-logo@2x.c05858ff.png";